import { render, staticRenderFns } from "./LanguageDropdownOptions.vue?vue&type=template&id=09fb7316&"
import script from "./LanguageDropdownOptions.vue?vue&type=script&lang=js&"
export * from "./LanguageDropdownOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports